import { useState, useEffect, useRef, Fragment, memo, useContext } from "react";
import style from "./../index.module.scss";
import styleUi from "./SettingPermissions.module.scss";
import allStyle from "./../../comm/global/all.module.scss";
import { v4 } from "uuid";
import styled from "styled-components";
import { CSSTransition } from 'react-transition-group';
import CloseIcon from '@mui/icons-material/Close';
import IconButton from '@mui/material/IconButton';
import ArrowBackIosNewIcon from '@mui/icons-material/ArrowBackIosNew';
import * as YStyled from "../../Styleds";
import FriendInfo from "../../comm/global/components/FriendInfo";
import LogItem from "../../comm/global/components/LogItem";
import ArrowForwardIosIcon from '@mui/icons-material/ArrowForwardIos';
import Switch from "../../comm/global/components/Switch";
import UnfoldMoreIcon from '@mui/icons-material/UnfoldMore';
import Popover from '@mui/material/Popover';
import { GameContext } from "../../GameContext";
import apiManager from '../../ApiManager';
const SettingPermissions = ({ setModalType, arg, addModalType }) => {
    const { userData, set_userData } = useContext(GameContext);
    const [inProp, setInProp] = useState(false);
    const [settingData, set_settingData] = useState({
        users_setting_friend_auto_add: userData.users_setting_friend_auto_add,
        users_setting_is_visible_friends: userData.users_setting_is_visible_friends,
        users_setting_is_visible_statistics: userData.users_setting_is_visible_statistics,
        users_setting_visibility_activity_summary: userData.users_setting_visibility_activity_summary,
    });//public aollow
    const actionType = ["", "公開", "好友", "私人"];
    const [actionTypeIndex, set_actionTypeIndex] = useState(0);
    const [anchorEl, setAnchorEl] = useState(null);
    const open = Boolean(anchorEl);
    const id = open ? 'simple-popover' : undefined;

    useEffect(() => {
        setInProp(true);
        document.title = "權限設定";
        console.log("userData", settingData);
    }, [])
    useEffect(() => {
        console.log("settingData", settingData)
        apiManager.fetchPut(`auth/setting`, settingData, 0).then(res => {
            console.log("res", res);
            set_userData(res);
        })
    }, [settingData])

    return (
        <div className={style.modal}>
            <CSSTransition in={inProp} timeout={{
                appear: 0,
                enter: 300,
                exit: 0,
            }} classNames={{
                enterActive: style.SwipePageEnterActive,
                enterDone: style.SwipePageEnterDone,
                exitActive: style.SwipePageExit,
                exitDone: style.SwipePageExitActive
            }}
                onExited={async () => {
                    await new Promise(resolve => requestAnimationFrame(resolve));
                    setModalType(prev => prev.filter(v => v.cls !== "SettingPermissions"))
                }}
            >
                <div className={`${style.SwipePage} ${style.Page}`} >
                    <div className={styleUi.app}>
                        <div className={styleUi.headerBar}>
                            <img src="./assets/ui/back.png" onClick={e => { setInProp(false) }} />
                        </div>

                        <div className={styleUi.view}>
                            <YStyled.Span color="#3C3C4399" fontWeight={400} size={13} style={{ alignSelf: "flex-start", paddingLeft: "1rem", marginTop: "2rem" }} >其他用戶查看權限</YStyled.Span>
                            <YStyled.Label style={{ width: "100%", marginTop: ".8rem", paddingRight: "0px", paddingBottom: ".4rem" }}>
                                <YStyled.Col>
                                    <YStyled.Row style={{ paddingRight: "1rem" }}>
                                        <YStyled.Col gap=".2rem">
                                            <YStyled.Span fontWeight={400} size={17} style={{ width: "25%" }}>朋友</YStyled.Span>
                                            <YStyled.Span fontWeight={400} size={15} color="#3c3c4380" >朋友數量、朋友名單</YStyled.Span>
                                        </YStyled.Col>
                                        <Switch defaultChecked={userData.users_setting_is_visible_friends === 1} onChange={e => {
                                            set_settingData((prevState) => ({
                                                ...prevState,
                                                users_setting_is_visible_friends: e.target.checked ? 1 : 0,
                                            }));
                                        }} />
                                    </YStyled.Row>
                                    <YStyled.Hr style={{ margin: ".8rem 0" }} />
                                    <YStyled.Row style={{ paddingRight: "1rem" }}>
                                        <YStyled.Col gap=".2rem">
                                            <YStyled.Span fontWeight={400} size={17} style={{ width: "25%" }}>統計</YStyled.Span>
                                            <YStyled.Span fontWeight={400} size={15} color="#3c3c4380" >野放次數、野放頻率</YStyled.Span>
                                        </YStyled.Col>
                                        <Switch defaultChecked={userData.users_setting_is_visible_statistics === 1} onChange={e => {
                                            set_settingData((prevState) => ({
                                                ...prevState,
                                                users_setting_is_visible_statistics: e.target.checked ? 1 : 0,
                                            }));
                                        }} />
                                    </YStyled.Row>
                                    <YStyled.Hr style={{ margin: ".8rem 0 .4rem 0" }} />
                                    <YStyled.Row style={{ paddingRight: "1rem" }}>
                                        <YStyled.Span fontWeight={400} size={17} style={{ width: "25%" }}>活動摘要</YStyled.Span>
                                        <YStyled.Row className={`${styleUi.actionSelect} ${open ? styleUi.active : ""}`} onClick={e => {
                                            setAnchorEl(e.currentTarget);
                                        }}>
                                            <YStyled.Span fontWeight={400} size={17} >{actionType[settingData.users_setting_visibility_activity_summary]}</YStyled.Span>
                                            <UnfoldMoreIcon />
                                        </YStyled.Row>
                                        <Popover
                                            id={id}
                                            open={open}
                                            anchorEl={anchorEl}
                                            onClose={e => { setAnchorEl(null); }}
                                            anchorOrigin={{
                                                vertical: 'bottom',
                                                horizontal: 'center',
                                            }}
                                            transformOrigin={{
                                                vertical: 'top',
                                                horizontal: 'center',
                                            }}
                                            slotProps={{
                                                paper: {
                                                    className: styleUi.titlePopover,
                                                },
                                            }}
                                        >
                                            {actionType.map((v, k) => {
                                                return <>
                                                    {v !== "" &&
                                                        <YStyled.Row onClick={e => {
                                                            set_settingData((prevState) => ({
                                                                ...prevState,
                                                                users_setting_visibility_activity_summary: k,
                                                            }));
                                                            setAnchorEl(null);
                                                        }}>
                                                            <YStyled.Span size={17} fontWeight={400}>{v}</YStyled.Span>
                                                            {k === settingData.users_setting_visibility_activity_summary &&
                                                                <img src="./assets/ui/checkmark.svg" />
                                                            }
                                                        </YStyled.Row>
                                                    }
                                                </>
                                            })}
                                        </Popover>
                                    </YStyled.Row>
                                </YStyled.Col>
                            </YStyled.Label>

                            <YStyled.Span color="#3C3C4399" fontWeight={400} size={13} style={{ alignSelf: "flex-start", paddingLeft: "1rem", marginTop: "2rem" }} >交友邀請設定</YStyled.Span>
                            <YStyled.Label style={{ width: "100%", marginTop: ".5rem", paddingRight: "0px" }}>
                                <YStyled.Col>
                                    <YStyled.Row style={{ paddingRight: "1rem", cursor: "pointer" }} onClick={e => {
                                        set_settingData((prevState) => ({
                                            ...prevState,
                                            users_setting_friend_auto_add: 1,
                                        }));
                                    }}>
                                        <YStyled.Span fontWeight={400} size={17} >所有人都可以加我為好友</YStyled.Span>
                                        {settingData.users_setting_friend_auto_add === 1 &&
                                            <img src="./assets/ui/checkmark.svg" />
                                        }
                                    </YStyled.Row>
                                    <YStyled.Hr style={{ margin: ".8rem 0" }} />
                                    <YStyled.Row style={{ paddingRight: "1rem", cursor: "pointer" }} onClick={e => {
                                        set_settingData((prevState) => ({
                                            ...prevState,
                                            users_setting_friend_auto_add: 0,
                                        }));
                                    }}>
                                        <YStyled.Span fontWeight={400} size={17} >經過我同意後成為好友</YStyled.Span>
                                        {settingData.users_setting_friend_auto_add !== 1 &&
                                            <img src="./assets/ui/checkmark.svg" />
                                        }
                                    </YStyled.Row>
                                </YStyled.Col>
                            </YStyled.Label>
                        </div>
                    </div>
                </div>
            </CSSTransition>
        </div>
    );
}

export default memo(SettingPermissions);